import styled from "styled-components";
import { TextField as MaterialTextField } from "@material-ui/core";

export const TextField = styled(MaterialTextField)`
    min-width: 200px;
`;
